import { useEffect, useRef, useState } from "react";
import { animate, useInView, useReducedMotion } from "framer-motion";
import { Trophy, CalendarDays, Users, Clock } from "lucide-react";
import { club, squad } from "../../data/sep26Data";

const Count = ({ to, pad = 0 }) => {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, margin: "-10%" });
  const reduce = useReducedMotion();
  const [val, setVal] = useState(reduce ? to : 0);

  useEffect(() => {
    if (!inView || reduce) return undefined;
    const controls = animate(0, to, {
      duration: 1.4,
      ease: [0.23, 1, 0.32, 1],
      onUpdate: (v) => setVal(Math.round(v)),
    });
    return () => controls.stop();
  }, [inView, to, reduce]);

  return <span ref={ref}>{String(val).padStart(pad, "0")}</span>;
};

const players = squad.filter((s) => s.number !== "DT").length;

const items = [
  { Icon: Trophy, value: <Count to={club.titles} pad={2} />, label: "Campeonatos" },
  { Icon: CalendarDays, value: <>{club.founded}</>, label: "Fundación" },
  { Icon: Users, value: <Count to={players} />, label: "En la plantilla" },
  { Icon: Clock, value: <>Lunes</>, label: "7 a 11 pm, por sorteo" },
];

export const Marcador26 = () => (
  <section data-testid="s26-marcador" className="relative z-10 -mt-px" style={{ background: "var(--ink)" }}>
    <div className="wrap">
      <ul
        className="grid grid-cols-2 lg:grid-cols-4 border-y"
        style={{ borderColor: "var(--line)" }}
      >
        {items.map(({ Icon, value, label }, i) => (
          <li
            key={label}
            className={`flex items-center gap-4 py-7 px-2 sm:px-6 ${i % 2 === 1 ? "border-l" : ""} ${i > 0 ? "lg:border-l" : ""} ${i > 1 ? "border-t lg:border-t-0" : ""}`}
            style={{ borderColor: "var(--line)" }}
          >
            <Icon size={28} strokeWidth={1.5} style={{ color: "var(--gold)" }} aria-hidden="true" />
            <div>
              <div className="display text-[clamp(34px,4vw,52px)] tabular-nums">{value}</div>
              <div className="label mt-1" style={{ color: "var(--muted)" }}>{label}</div>
            </div>
          </li>
        ))}
      </ul>
    </div>
  </section>
);
